import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MultipleSelectFieldFormModalData } from 'src/app/interface/components/forms/multiple-select-field-form.interface';
import { MultipleSelectOptionValue } from 'src/app/interface/components/forms/multiple-select-field-form.interface';

@Component({
  selector: 'common-multiple-select-field-form-modal',
  templateUrl: './multiple-select-field-form-modal.component.html',
  styleUrls: ['./multiple-select-field-form-modal.component.scss'],
})
export class MultipleSelectFieldFormModalComponent<T extends MultipleSelectOptionValue = MultipleSelectOptionValue> implements OnInit {
  @Input() title: string = '';
  @Input() inputLabel: string = '';
  @Input() options: T[] = [];
  @Input() selectedValues: T[] = [];
  @Input() labelButtonCancel: string = 'maia.doors.button.cancel';
  @Input() labelButtonSave: string = 'maia.doors.button.save';
  @Input() displayProperty: string = '';
  @Input() displayFunction: ((item: T) => string) | null = null;
  @Input() isObjectMode: boolean = false;
  @Input() loading: boolean = false;

  @Output() save = new EventEmitter<T[]>();
  @Output() cancel = new EventEmitter<void>();

  selectedOptions: T[] = [];

  constructor(
    private matDialogRef: MatDialogRef<MultipleSelectFieldFormModalComponent<T>>,
    @Inject(MAT_DIALOG_DATA) public data: MultipleSelectFieldFormModalData<T>,
  ) {
    if (this.data) {
      this.title = this.data.title || this.title;
      this.inputLabel = this.data.inputLabel || this.inputLabel;
      this.options = this.data.options || this.options;
      this.selectedValues = this.data.selectedValues || this.selectedValues;
      this.labelButtonCancel = this.data.labelButtonCancel || this.labelButtonCancel;
      this.labelButtonSave = this.data.labelButtonSave || this.labelButtonSave;
      this.displayProperty = this.data.displayProperty || this.displayProperty;
      this.displayFunction = this.data.displayFunction || this.displayFunction;
      this.isObjectMode =
        this.data.isObjectMode !== undefined ? this.data.isObjectMode : this.isObjectMode;
    }

    this.selectedOptions = this.selectedValues || [];
  }

  ngOnInit(): void {}

  getDisplayValue(item: T): string {
    if (this.displayFunction) {
      return this.displayFunction(item);
    }

    if (this.isObjectMode && this.displayProperty && item && typeof item === 'object') {
      return String((item as Record<string, unknown>)[this.displayProperty] ?? '');
    }

    return item != null ? String(item) : '';
  }

  onOptionSelected(selectedValues: T[]): void {
    this.selectedOptions = selectedValues || [];
  }

  onEventClose(): void {
    this.matDialogRef.close();
  }

  onEventCancel(): void {
    this.cancel.emit();
    this.matDialogRef.close();
  }

  onEventSave(): void {
    if (this.selectedOptions.length > 0) {
      this.save.emit(this.selectedOptions);
      this.matDialogRef.close(this.selectedOptions);
    }
  }
}
